import LegalPage, { ToFill } from "@/components/LegalPage";

export default function MentionsLegales() {
  return (
    <LegalPage title="Mentions légales" updatedAt="2026-02-15" testid="page-mentions-legales">
      <h2>Éditeur du site</h2>
      <p>
        <strong>Service :</strong> RevenueFix AI<br />
        <strong>Site :</strong> revenuefixai.com<br />
        <strong>Nom commercial :</strong> VALQORY<br />
        <strong>Statut :</strong> Entrepreneur individuel — micro-entreprise<br />
        <strong>SIREN :</strong> 109 877 399<br />
        <strong>SIRET :</strong> 109 877 399 00013<br />
        <strong>Adresse professionnelle :</strong> 17 Place Charles Albert, 73250 Saint-Pierre-d'Albigny, France<br />
        <strong>Email :</strong> <a href="mailto:damienallais3@gmail.com">damienallais3@gmail.com</a><br />
        <strong>Directeur de la publication :</strong> Damien Allais
      </p>
      <p className="text-xs text-slate-500">
        En qualité d'entrepreneur individuel exerçant sous le régime de la micro-entreprise, l'éditeur
        n'est pas assujetti à la TVA (mention « TVA non applicable, art. 293 B du CGI ») et n'est pas
        immatriculé au RCS lorsqu'il exerce une activité non commerciale ; la mention SIRET ci-dessus
        vaut identification légale.
      </p>

      <h2>Hébergement</h2>
      <p>
        RevenueFix AI est hébergé via la plateforme <strong>Emergent</strong>.
      </p>
      <p>
        <strong>Hébergeur / prestataire d'infrastructure :</strong><br />
        Emergent Labs Inc.<br />
        2380 Via Espada<br />
        Pleasanton, CA 94566<br />
        États-Unis<br />
        Contact : <a href="mailto:support@emergent.sh">support@emergent.sh</a>
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu de RevenueFix AI (textes, graphismes, logos, code, rapports générés)
        est protégé par le droit de la propriété intellectuelle. Toute reproduction ou représentation
        totale ou partielle sans autorisation écrite préalable est interdite.
      </p>

      <h2>Responsabilité</h2>
      <p>
        RevenueFix AI met tout en œuvre pour fournir des informations fiables mais ne saurait garantir
        l'exactitude, la complétude ou l'actualité des données extraites automatiquement des sites
        analysés. Le client professionnel reste seul responsable des décisions prises sur la base
        des rapports.
      </p>

      <h2>Droit applicable</h2>
      <p>
        Les présentes mentions sont régies par le <strong>droit français</strong>.
      </p>
    </LegalPage>
  );
}
